import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse, NewUser, User } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.users.createUser],
    mutationFn: async (userData: NewUser): Promise<User> => {
      const response = await XHRAuthorizedClient.post<ApiResponse<User>>(
        ENDPOINTS.users.create,
        userData
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('유저 생성 오류:', error);
    },
  });
};
